import { trySetAccount, localStorageIsBms } from "./localStorageOverride"
import React from "react"
import { createRoot } from "react-dom/client"
import Core from "./external/core/Core"
import Account from "./external/core/Account"
import { loadPackage } from "./external/core/loadPackage"
import API from "eos/context/api"
import "array-flat-polyfill"

// if (process.env.NODE_ENV !== "production") {
//   const whyDidYouRender = require("@welldone-software/why-did-you-render");
//   whyDidYouRender(React, { trackHooks: false });
// }
// if (process.env.NODE_ENV !== "production") {
//   const { whyDidYouUpdate } = require("why-did-you-update");
//   whyDidYouUpdate(React);
// }

if (window.matchMedia("(prefers-color-scheme: dark)").matches) import("./basicDarkStyle.css").then(() => {})
else import("./basicStyle.css").then(() => {})

const PACKAGES = [
  "eos",
  "eos-navigation",
  "eos-network",
  "eos-notifications",
  "eos-users",
  "eos-addmenu",
  "eos-collection",
  "eos-filemanager",
]

const account = new Account()
const root = createRoot(document.getElementById("root"))

function renderApp(appData) {
  const urlSearchParams = new URL(window.location.href).searchParams

  const arrigoId = urlSearchParams.get("arrigoId")
  const code = urlSearchParams.get("code")
  const redirectAccount = urlSearchParams.get("account")

  if (arrigoId || code || redirectAccount) {
    if (arrigoId === "1") {
      localStorage.setItem("arrigoId", true)
    } else {
      localStorage.removeItem("arrigoId")
    }

    if (code) {
      const locale = urlSearchParams.get("locale")
      if (locale) {
        localStorage.setItem("locale", locale)
      }

      localStorage.setItem("oauth", code)
      localStorage.removeItem("currentAccount")
      sessionStorage.removeItem("currentAccount")
      sessionStorage.removeItem("authToken")

      if (localStorageIsBms()) {
        // Since BMS doesn't have accounts, clear the credentials cache.
        localStorage.removeItem("persist:session")
      }
    }

    if (redirectAccount) {
      // Remove the logged in account and authtoken
      localStorage.removeItem("currentAccount")
      sessionStorage.removeItem("currentAccount")
      sessionStorage.removeItem("authToken")

      // Put in localstorage and clear the url
      localStorage.setItem("redirectAccount", redirectAccount)
    }

    // ^--- We remove this value from local storage when showing the button in the ArrigoIdLogin.js-component
    window.location.href =
      window.location.origin + window.location.pathname + window.location.hash + (urlSearchParams.get("state") || "")

    return
  }
  root.render(
    <Core
      packages={PACKAGES}
      account={account}
      appData={appData}
    />
  )
}

sessionStorage.removeItem("refreshing")
sessionStorage.removeItem("maintenance")
sessionStorage.removeItem("reloadingPage")

// Fetch all bootstrap data AND pre-load all packages before root.render() so
// Core can initialize synchronously — avoiding React 18 concurrent-mode
// batching of setState from Promise callbacks which deferred the re-render
// (causing blank screen until DevTools forced a synchronous flush).
const initialLang = localStorage.selectedLang
  ? JSON.parse(localStorage.selectedLang).name
  : "en"

trySetAccount().then(async () => {
  if (typeof window.IntersectionObserver === "undefined") {
    await import("intersection-observer")
  }

  const [loginConfig, theme, translations, ...preloadedModules] = await Promise.all([
    API.retrieveLoginConfig().catch(() => ({ ok: false })),
    API.retrieveThemeConfig().catch(() => ({})),
    API.retrieveTranslations(initialLang).catch(() => ({})),
    ...PACKAGES.map((name) =>
      loadPackage(name).catch((err) => {
        console.error(`Package "${name}" failed to preload:`, err)
        return null
      })
    ),
  ])

  renderApp({ loginConfig, theme, translations, translationsLang: initialLang, preloadedModules })
})
